"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralReportSearchForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const date_fns_1 = require("date-fns");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const mui_form_search_1 = require("@dzambalaorg/mui-form-search");
const ReferralReportSearchForm = () => {
    return ((0, jsx_runtime_1.jsx)(mui_form_search_1.SearchWithFilters, { initialValues: {
            startTimestamp: (0, date_fns_1.startOfMonth)((0, date_fns_1.subMonths)(new Date(), 1)).toISOString(),
            endTimestamp: (0, date_fns_1.endOfMonth)((0, date_fns_1.addMonths)(new Date(), 1)).toISOString(),
        }, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, spacing: 2, alignItems: "flex-end", children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 6 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { name: "startTimestamp" }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 6 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { name: "endTimestamp" }) })] }) }));
};
exports.ReferralReportSearchForm = ReferralReportSearchForm;
//# sourceMappingURL=index.js.map